import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";
import { errMsg } from "../lib/api";
import { ArrowLeft, LogIn } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("Hoş geldiniz!");
      if (u.role === "owner" || u.role === "waiter") nav("/panel");
      else nav("/menu");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B0B0C] flex items-center justify-center px-5 py-10 relative overflow-hidden">
      <div className="absolute inset-0 grain" />
      <Link to="/" className="absolute top-6 left-6 text-zinc-400 hover:text-[#FFE599] flex items-center gap-2 text-sm" data-testid="login-back-btn">
        <ArrowLeft size={16} /> Ana Sayfa
      </Link>
      <div className="relative w-full max-w-md card-lux p-8 sm:p-10 fade-up" data-testid="login-card">
        <div className="text-center mb-8">
          <img src="/cafein-icon.png" alt="CAFE-İN" className="h-16 w-16 object-contain mx-auto" />
          <h1 className="mt-4 font-serif text-3xl gold-text">Giriş Yap</h1>
          <p className="text-sm text-zinc-400 mt-1">CAFE-İN hesabınıza giriş yapın</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs font-mono uppercase tracking-widest text-zinc-400">E-posta</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="lux-input mt-2" placeholder="ornek@mail.com" data-testid="login-email" />
          </div>
          <div>
            <label className="text-xs font-mono uppercase tracking-widest text-zinc-400">Şifre</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="lux-input mt-2" placeholder="••••••••" data-testid="login-password" />
          </div>
          <button type="submit" disabled={busy} className="btn-gold w-full py-3 rounded-xl flex items-center justify-center gap-2" data-testid="login-submit">
            <LogIn size={18} /> {busy ? "Giriş yapılıyor..." : "Giriş Yap"}
          </button>
        </form>
        <p className="text-center text-sm text-zinc-400 mt-6">
          Hesabınız yok mu? <Link to="/kayit" className="text-[#FFE599] hover:underline" data-testid="login-register-link">Kayıt Olun</Link>
        </p>
      </div>
    </div>
  );
}
